import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import { DashboardLayout } from '@/components/layouts/dashboard-layout';
import { DashboardPage } from '@/pages/dashboard';
import { OrdersPage } from '@/pages/orders';
import { ProductsPage } from '@/pages/products';
import { CustomersPage } from '@/pages/customers';
import { SettingsPage } from '@/pages/settings';
import { LoginPage } from '@/pages/login';
import { CategoriesPage } from '@/pages/categories';
import { CouponsPage } from '@/pages/coupons';
import { AuthProvider } from '@/contexts/auth-context';
import { AuthGuard } from '@/components/auth-guard';

function App() {
    return (
        <AuthProvider>
            <Routes>
                {/* Auth routes */}
                <Route path="/login" element={<LoginPage />} />

                {/* Protected routes */}
                <Route
                    path="/"
                    element={
                        <AuthGuard>
                            <DashboardLayout />
                        </AuthGuard>
                    }
                >
                    <Route index element={<Navigate to="/dashboard" replace />} />
                    <Route path="dashboard" element={<DashboardPage />} />
                    <Route path="orders" element={<OrdersPage />} />
                    <Route path="products" element={<ProductsPage />} />
                    <Route path="categories" element={<CategoriesPage />} />
                    <Route path="coupons" element={<CouponsPage />} />
                    <Route path="customers" element={<CustomersPage />} />
                    <Route path="settings" element={<SettingsPage />} />
                </Route>

                {/* 404 */}
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
            <Toaster />
        </AuthProvider>
    );
}

export default App;
